import { render, staticRenderFns } from "./RoleListContainer.vue?vue&type=template&id=432811c2"
import script from "./RoleListContainer.vue?vue&type=script&lang=js"
export * from "./RoleListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports